/**
 * Owner: Masa Bayu
 * File: RouteAnnouncer.tsx
 * Date:Time: 2026-09-15 20:00
 * Description: Polite aria-live announcer for QXRead shell route changes.
 */

export interface RouteAnnouncerProps {
  readonly path: string;
  readonly allowed: boolean;
}

function announceText(path: string, allowed: boolean): string {
  if (!allowed) {
    return `Route closed: ${path}`;
  }
  if (path === '/') {
    return 'Home';
  }
  if (path.startsWith('/publication/')) {
    return `Publication ${path.slice('/publication/'.length)}`;
  }
  return path.replace(/^\//, '') || 'Home';
}

export function RouteAnnouncer({ path, allowed }: RouteAnnouncerProps) {
  return (
    <div className="route-announcer" aria-live="polite" aria-atomic="true" role="status">
      {announceText(path, allowed)}
    </div>
  );
}
